import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { LoadingBlock } from "@/components/AsyncState";
import { VendorVenueFormPage } from "@/components/vendor/venue-form/VendorVenueFormPage";
import { getStoredVendorVenueId } from "@/lib/vendorPortal";

export const Route = createFileRoute("/vendor/venue-daten")({
  head: () => ({ meta: [{ title: "Venue-Daten · Venue Portal" }] }),
  component: VendorVenueDatenRoute,
});

function VendorVenueDatenRoute() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!getStoredVendorVenueId()) {
      void navigate({ to: "/vendor/login", replace: true });
      return;
    }
    setReady(true);
  }, [navigate]);

  if (!ready) return <LoadingBlock label="Venue-Daten laden…" />;
  return <VendorVenueFormPage />;
}
